// import { grey } from '@mui/material/colors';
// import { alpha } from '@mui/material/styles';

// // ----------------------------------------------------------------------

// function createGradient(color1, color2) {
//   return `linear-gradient(to bottom, ${color1}, ${color2})`;
// }

// // SETUP COLORS
// const GREY = {
//   300: '#F1F2F4',
//   400: '#FAFAFA',
//   500: '#A0AEC0',
//   600: '#718096',
//   700: '#ABABAB',
//   800: '#111827',
// };

// const PRIMARY = {
//   lighter: '#E7F7EF',
//   light: '#0CAF60',
//   main: '#297041',
// };

// const SECONDARY = {
//   main: '#EDB42E',
//   light: '#FE964A',
//   lighter: '#FFF0E6',
// };

// const WARNING = {
//   lighter: '#FFF0E6',
//   light: '#FD6A6A',
//   main: '#F63D58',
// };

// // const GRADIENTS = {
// //   primary: createGradient(PRIMARY.light, PRIMARY.main),
// //   info: createGradient(INFO.light, INFO.main),
// //   success: createGradient(SUCCESS.light, SUCCESS.main),
// //   warning: createGradient(WARNING.light, WARNING.main),
// //   error: createGradient(ERROR.light, ERROR.main),
// // };

// const CHART_COLORS = {
//   violet: ['#826AF9', '#9E86FF', '#D0AEFF', '#F7D2FF'],
//   blue: ['#2D99FF', '#83CFFF', '#A5F3FF', '#CCFAFF'],
//   green: ['#2CD9C5', '#60F1C8', '#A4F7CC', '#C0F2DC'],
//   yellow: ['#FFE700', '#FFEF5A', '#FFF7AE', '#FFF3D6'],
//   red: ['#FF6C40', '#FF8F6D', '#FFBD98', '#FFF2D4'],
// };

// const palette = {
//   common: { black: '#271E11', white: '#FFFFFF' },
//   primary: { ...PRIMARY },
//   secondary: { ...SECONDARY },
//   warning: { ...WARNING },
//   grey: GREY,
//   chart: CHART_COLORS,
//   divider: '#EEEFF2',
//   text: { primary: GREY[800], secondary: GREY[600], disabled: GREY[500] },
//   background: { paper: '#FFFFFF' },
//   error: { main: '#F63D58' },
// };

// export default palette; 
import { grey } from '@mui/material/colors';
import { alpha } from '@mui/material/styles';

// ----------------------------------------------------------------------

function createGradient(color1, color2) {
  return `linear-gradient(to bottom, ${color1}, ${color2})`;
}

// SETUP COLORS
const GREY = {
  300: '#F1F2F4',
  400: '#FAFAFA',
  500: '#A0AEC0',
  600: '#718096',
  700: '#ABABAB',
  800: '#111827',
};

const PRIMARY = {
  lighter: '#E7F7EF',
  light: '#0CAF60',
  main: '#297041',
};

const SECONDARY = {
  main: '#EDB42E',
  light: '#FE964A',
  lighter: '#FFF0E6',
};

const WARNING = {
  lighter: '#FFF0E6',
  light: '#FD6A6A',
  main: '#F63D58',
};

// const GRADIENTS = {
//   primary: createGradient(PRIMARY.light, PRIMARY.main),
//   info: createGradient(INFO.light, INFO.main),
//   success: createGradient(SUCCESS.light, SUCCESS.main),
//   warning: createGradient(WARNING.light, WARNING.main),
//   error: createGradient(ERROR.light, ERROR.main),
// };

const CHART_COLORS = {
  violet: ['#826AF9', '#9E86FF', '#D0AEFF', '#F7D2FF'],
  blue: ['#2D99FF', '#83CFFF', '#A5F3FF', '#CCFAFF'],
  green: ['#2CD9C5', '#60F1C8', '#A4F7CC', '#C0F2DC'],
  yellow: ['#FFE700', '#FFEF5A', '#FFF7AE', '#FFF3D6'],
  red: ['#FF6C40', '#FF8F6D', '#FFBD98', '#FFF2D4'],
};

const palette = {
  common: { black: '#271E11', white: '#FFFFFF' },
  primary: { ...PRIMARY },
  secondary: { ...SECONDARY },
  warning: { ...WARNING },
  grey: GREY,
  chart: CHART_COLORS,
  divider: '#EEEFF2',
  text: { primary: GREY[800], secondary: GREY[600], disabled: GREY[500] },
  background: { paper: '#FFFFFF' },
  error: { main: '#F63D58' },
};

export default palette;